import { Input } from 'antd';
import { MaskedInput } from 'antd-mask-input';
import { InputHTMLAttributes, useState } from 'react';

interface InputColorProps extends InputHTMLAttributes<HTMLInputElement> {
  onValueChange: (value: string) => void;
  defaultValue?: string;
  ['aria-label']?: string;
}
export const InputColor = ({
  onValueChange,
  defaultValue,
  onBlur,
  ['aria-label']: ariaLabel,
}: InputColorProps) => {
  const [value, setValue] = useState(defaultValue);

  const handleChange = (value: string) => {
    setValue(value);
    onValueChange(value);
  };
  return (
    <MaskedInput
      type='text'
      mask={/^#[0-9a-f]{0,6}$/i}
      value={value}
      aria-label={ariaLabel}
      style={{
        backgroundColor: 'transparent',
        border: '1px solid rgb(67, 67, 67)',
        color: 'rgba(255, 255, 255, 0.85)',
      }}
      onChange={({ target }) => handleChange(target.value)}
      onBlur={e => {
        onBlur?.(e);
        onValueChange(e.target.value);
      }}
      prefix={
        <div
          style={{
            position: 'relative',
            display: 'flex',
            border: '1px solid rgb(67, 67, 67)',
            height: '20px',
            width: '20px',
            backgroundColor: `${value}`,
            marginRight: 5,
          }}
        >
          <Input
            type='color'
            style={{
              height: '24px',
              width: '24px',
              opacity: 0,
            }}
            onChange={({ target }) => setValue(target.value)}
          />
        </div>
      }
    />
  );
};
